<template>
  <q-bar class="bg-white">
    <q-btn
      dense
      flat
      round
      :to="{ name: 'OrderDetail', params: { id: $route.params.id } }"
    >
      <i class="fas fa-chevron-left"></i>
    </q-btn>
    <div class="col text-center">{{ $t('trade.enableSharedOrder.title') }}</div>
  </q-bar>

  <div>
    <div class="q-pl-md q-py-sm text-primary">
      {{ `${$t('trade.tradeId')}: ${tradeId}` }}
    </div>
    <q-separator />
    <div class="q-pa-md row justify-between">
      <div>name</div>
      <div>button</div>
    </div>
    <q-separator />
  </div>
</template>
